import { Injectable } from '@angular/core';
import { ApiResourceService } from "libraries/service/apiResource/apiResource.service";
import { Observable } from "rxjs";
import {
    RequestForGetTicketType,
    ResponseForConvertOfferAfx2jsonType, RequestForTicketingReportSearch, ResponseForConvertTicketAfx2jsonType
} from "@afidium/ts-facade";
import { ExportFormats, IApiExportResponse } from "libraries/interfaces/IApiExportResponse";


export enum EFiedsNames {
    whenIssued = "whenIssued",
    type = "type",
    accountCode = "accountCode",
    travellerTypology = "travellerTypology",
}
export interface ISearchTicketRequest {
    ticketNumber: string;
    [EFiedsNames.whenIssued]: string;
    [EFiedsNames.accountCode]: string;
    [EFiedsNames.travellerTypology]: string;
    [EFiedsNames.type]: string;
}


@Injectable()
export class AirTicketResourceService {

    constructor(
        private readonly apiResourceService: ApiResourceService,
    ) {
    }

    public search(searchRequest: RequestForGetTicketType): Observable<ResponseForConvertTicketAfx2jsonType> {
        return this.apiResourceService.postOne<RequestForGetTicketType, ResponseForConvertTicketAfx2jsonType>(
            this.apiResourceService.getApiUrl('air', 'bookings','ticket', 'search'),
            searchRequest
        );
    }

    public searchTickets(request: RequestForTicketingReportSearch): Observable<ResponseForConvertOfferAfx2jsonType> {
        return this.apiResourceService.postOne<RequestForTicketingReportSearch, ResponseForConvertOfferAfx2jsonType>(
            this.apiResourceService.getApiUrl('tkt_report', 'search'),
            request
        );
    }

    public export(request: RequestForTicketingReportSearch, format: ExportFormats): Observable<IApiExportResponse> {
        return this.apiResourceService.postOne<RequestForTicketingReportSearch, IApiExportResponse>(
            this.apiResourceService.getApiUrl('tkt_report', 'search', 'export', format),
            request
        );
    }
}

